const mutations = {

  SET_EVENTS: (state, data) => (state.events = data),
  SET_EVENT_NAMES: (state, data) => (state.event_names = data),
  SET_EVENT_TYPES: (state, data) => (state.event_types = data),
}

export default mutations
